import components_plugin_KR1HBZs4kY from "/home/zedplan/www/divas-web-ssr/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import vueuse_head_polyfill_M7DKUOwKp5 from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/head/runtime/plugins/vueuse-head-polyfill.js";
import router_jmwsqit4Rs from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import prefetch_client_5tzzN0oIVL from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import chunk_reload_client_UciE0i6zes from "/home/zedplan/www/divas-web-ssr/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import _1_i18n_pIpqaF7fxP from "/home/zedplan/www/divas-web-ssr/plugins/1.i18n.ts";
import auth_client_4lHQFpoKNF from "/home/zedplan/www/divas-web-ssr/plugins/auth.client.ts";
import eventbus_client_hXjVpwcj1U from "/home/zedplan/www/divas-web-ssr/plugins/eventbus.client.ts";
import sentry_3AyO8nEfhE from "/home/zedplan/www/divas-web-ssr/plugins/sentry.ts";
import socialShare_mOLWZwVWh9 from "/home/zedplan/www/divas-web-ssr/plugins/socialShare.ts";
import themeManager_client_4hB6OZR7P8 from "/home/zedplan/www/divas-web-ssr/plugins/themeManager.client.ts";
import vueToast_client_LXSTX0Nibh from "/home/zedplan/www/divas-web-ssr/plugins/vueToast.client.ts";
export default [
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  vueuse_head_polyfill_M7DKUOwKp5,
  router_jmwsqit4Rs,
  prefetch_client_5tzzN0oIVL,
  chunk_reload_client_UciE0i6zes,
  _1_i18n_pIpqaF7fxP,
  auth_client_4lHQFpoKNF,
  eventbus_client_hXjVpwcj1U,
  sentry_3AyO8nEfhE,
  socialShare_mOLWZwVWh9,
  themeManager_client_4hB6OZR7P8,
  vueToast_client_LXSTX0Nibh
]